module.exports = __webpack_public_path__ + "img/by_vip.93170645.png";